<template>
  <v2-card :no-padding="true">
    <v2-table
      :columns="columns"
      :items="selections"
    >
      <template #cell(selectionName)="{ item }">
        <a
          class="v2-sales-analytics-list__link"
          @click="$emit('click-selection', item)"
        >
          {{ item.selectionName }}
        </a>
      </template>
      <template #cell(email)="{ item }">
        <span class="v2-font-semibold">
          {{ item.email }}
        </span>
      </template>
      <template #cell(sharedDate)="{ item }">
        {{ getDateAndTime(item.sharedDate) }}
      </template>
      <template #cell(isEmailOpened)="{ item }">
        {{ item.isEmailOpened ? 'Yes' : 'No' }}
      </template>
      <template #cell(isClicked)="{ item }">
        {{ item.isClicked ? 'Yes' : 'No' }}
      </template>
      <template #cell(lastEmailOpenedAt)="{ item }">
        {{ item.isEmailOpened ? getDateAndTime(item.lastEmailOpenedAt) : '' }}
      </template>
    </v2-table>
  </v2-card>
</template>

<script>
import V2Card from '@/components/v2/V2Card.vue'
import V2Table from '@/components/v2/V2Table.vue'

export default {
  name: 'V2SalesAnalyticsList',
  components: {
    V2Card,
    V2Table,
  },
  props: {
    selections: {
      type: Array,
      default: () => [],
    },
    getDateAndTime: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      columns: [
        { key: 'selectionName', label: 'Wishlist Name' },
        { key: 'storeName', label: 'Store Name' },
        { key: 'email', label: 'Shared with' },
        { key: 'sharedDate', label: 'Shared Date & Time' },
        { key: 'isEmailOpened', label: 'Email Opened' },
        { key: 'isClicked', label: 'Wishlist Clicked' },
        { key: 'lastEmailOpenedAt', label: 'Opened Date & Time' },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.v2-sales-analytics-list {
  &__link {
    color: var(--v2-primary);
    font-weight: 500;
    cursor: pointer;
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
